import React from 'react';
import type { UpvoteResults } from '../types';
import { useResults } from '../../hooks/useResults';
import { ResultsView } from './ResultsView';

interface ResultListProps {
  isMigrated: boolean;
  publicKey: string;
  interactiveContentChoiceId: string | undefined;
}

export const ResultsViewDataHandler = ({
  isMigrated,
  publicKey,
  interactiveContentChoiceId,
}: ResultListProps) => {
  const { responses } = useResults<UpvoteResults>({
    isMigrated,
    questionPublicKey: publicKey,
    interactiveContentChoiceId,
    shouldFetch: true,
  }).data;
  const responseList = responses ?? [];

  const resultsWithoutUpvotes = responseList.filter((v) => !v.upvotes);

  const resultsWithUpvotes = [...responseList]
    .filter((response) => response.upvotes)
    .sort((a, b) => b.upvotes - a.upvotes);

  const maxVoteCount = Math.max(...resultsWithUpvotes.map((v) => v.upvotes));

  return (
    <ResultsView
      resultsWithUpvotes={resultsWithUpvotes}
      resultsWithoutUpvotes={resultsWithoutUpvotes}
      maxVoteCount={maxVoteCount}
    />
  );
};
